<script setup lang="ts">
import type { Component, HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface Props {
    title: string;
    description?: string;
    icon?: Component;
    class?: HTMLAttributes['class'];
}

defineProps<Props>();
</script>

<template>
    <div
        :class="
            cn(
                'flex min-h-100 animate-in flex-col items-center justify-center rounded-md border border-dashed p-8 text-center fade-in-50',
                $props.class,
            )
        "
    >
        <div
            v-if="icon"
            class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted"
        >
            <component :is="icon" class="h-10 w-10 text-muted-foreground" />
        </div>
        <div
            v-else-if="$slots.icon"
            class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted"
        >
            <slot name="icon" />
        </div>

        <h3 class="mt-4 text-lg font-semibold">{{ title }}</h3>
        <p
            v-if="description"
            class="mx-auto mt-2 mb-4 max-w-sm text-sm text-muted-foreground"
        >
            {{ description }}
        </p>

        <div v-if="$slots.default" class="mt-6">
            <slot />
        </div>
    </div>
</template>
